import axios from 'axios';
import  * as storage  from "app/data/storage";

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
     'Access-Control-Allow-Origin': '*',
    },
});

api.interceptors.request.use(
  (config) => {
    const accessToken = storage.get('accessToken');
    const role = storage.get('role') || '';

    const isViaCepRequest = config.url?.includes("viacep.com.br");

    if (!isViaCepRequest && config.url !== "/token/refresh" && config.url !== "auth/login" && config.url !== "/auth/register" && accessToken) {
        config.headers['Authorization'] = `Bearer ${accessToken}`;
        config.headers['role'] = role;
    }
    
    return config;
  },
  (error) => Promise.reject(error)
);



api.interceptors.response.use(
    (response) => response,
    async (error) => {
      if (error.response && error.response.data) {

        const originalConfig = error.config;
        if (originalConfig.url !== "auth/login" && error.response.status === 401) {
          storage.remove("accessToken");
          storage.remove("refreshToken");
          window.location.replace("/session/signin")
        }

        return Promise.reject(error);
      } else {
        return Promise.reject(error);
      }
    },
  );

export { api };


